import { useAppVariant, useTranslations } from "@jugl-web/utils";
import { FC, SVGProps, useMemo } from "react";
import { ReactComponent as InboxIcon } from "../components/KPICard/assets/inbox.svg";
import { ReactComponent as MessageIcon } from "../components/KPICard/assets/message.svg";
import { ReactComponent as AIAgentIcon } from "../components/KPICard/assets/ai-agent.svg";
import { ReactComponent as HumanUserIcon } from "../components/KPICard/assets/human-user.svg";
import { ChatsOverviewKPITotals } from "./useChatsOverviewKPIData";

export interface KPICardConfig {
  id: string;
  Icon: FC<SVGProps<SVGSVGElement>>;
  label: string;
  value: number;
}

export const useChatsOverviewKPICards = (
  totals: ChatsOverviewKPITotals | null
): KPICardConfig[] => {
  const { t } = useTranslations();
  const { isMobile } = useAppVariant();

  return useMemo(
    () => [
      {
        id: "total-chats",
        Icon: InboxIcon,
        label: t({
          id: "cx-analytics.total-chats",
          defaultMessage: "Total Chats",
        }),
        value: totals?.totalConversations || 0,
      },
      {
        id: "total-messages",
        Icon: MessageIcon,
        label: t({
          id: "cx-analytics.total-messages",
          defaultMessage: "Total Messages",
        }),
        value: totals?.totalMessages || 0,
      },
      {
        id: "total-ai-agent-messages",
        Icon: AIAgentIcon,
        label: t({
          id: "cx-analytics.total-ai-agent-messages",
          defaultMessage: "Total AI Agent Messages",
        }),
        value: totals?.aiReplies || 0,
        className: isMobile
          ? "bg-gradient-to-r from-[#F7F4FA] to-[#F6FDFF]"
          : undefined,
      },
      {
        id: "total-human-messages",
        Icon: HumanUserIcon,
        label: t({
          id: "cx-analytics.total-human-messages",
          defaultMessage: "Total Human Messages",
        }),
        value: totals?.humanSentMessages || 0,
      },
    ],
    [
      isMobile,
      t,
      totals?.aiReplies,
      totals?.humanSentMessages,
      totals?.totalConversations,
      totals?.totalMessages,
    ]
  );
};
